/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from 'react'
const InputImg = (props) => {
  const [file, setFile] = useState()
  const filePickerRef = useRef()

  useEffect(() => {
    if (!file) {
      return
    }
    const fileReader = new FileReader()
    fileReader.onload = () => {
      props.setAvatar(fileReader.result)
    }
    fileReader.readAsDataURL(file)
  }, [file])

  const pickedHandler = (event) => {
    let pickedFile
    if (event.target.files && event.target.files.length === 1) {
      pickedFile = event.target.files[0]
      setFile(pickedFile)
      props.handleInputs(event)
    }
  }

  return (
    <>
      <div className='profile-upload-box box-shadow'>
        <div className='inner-profile-upload-box'>
          <div className='d-flex align-items-center'>
            <div>{props.icon}</div>
            <div>
              <h5>{props.title}</h5>
            </div>
          </div>
          <div className='caption'>{props.caption}</div>
        </div>
        <input
          name={props.name}
          ref={filePickerRef}
          type='file'
          accept={props.accept}
          onChange={pickedHandler}
        />
      </div>
    </>
  )
}
export default InputImg
